import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/zh-cn/services/regulatory-toxicology/")({
  head: () => buildRouteHead("/zh-cn/services/regulatory-toxicology"),
  component: ServicePage,
});
